import { render, staticRenderFns } from "./LaudoAnaliseCoberturaSolo.vue?vue&type=template&id=2232637a&scoped=true&lang=pug"
import script from "./LaudoAnaliseCoberturaSolo.vue?vue&type=script&lang=js"
export * from "./LaudoAnaliseCoberturaSolo.vue?vue&type=script&lang=js"
import style0 from "./LaudoAnaliseCoberturaSolo.vue?vue&type=style&index=0&id=2232637a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232637a",
  null
  
)

export default component.exports